// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5416) return "static/chunks/5416-094bc9efba966821.js";
	if (chunkId === 8972) return "static/chunks/8972-94d0a88845fb7982.js";
	if (chunkId === 2830) return "static/chunks/2830-975f5b1f8e1e32f7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"22":"4940d87671eab2fa","8411":"d5ad6f2b2d8a151e","8832":"98641bc9fa54214f"}[chunkId] + ".js";
};